import { render, staticRenderFns } from "./MissingTravel.vue?vue&type=template&id=14ec5ef3&scoped=true"
import script from "./MissingTravel.vue?vue&type=script&lang=js"
export * from "./MissingTravel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ec5ef3",
  null
  
)

export default component.exports